import graphql__1ac4ae48bed5d63aced0 from "./__generated__/AuthenticationManagerQuery.graphql.js";import { graphql } from "react-relay";

import ModalLoader from "../Modals/ModalLoader";
import AppQueryRenderer from "../AppQueryRenderer";
import AuthenticationModal from "./AuthenticationModal";
import AuthenticationManagerErrorBoundary from "../ErrorBoundaries/AuthenticationManagerErrorBoundary";

const AuthenticationManager = props => {
  return (
    <AppQueryRenderer
      query={AuthenticationManagerQuery}
      loader={<ModalLoader />}
      component={AuthenticationModal}
      additionalProps={props}
      ErrorBoundary={props => (
        <AuthenticationManagerErrorBoundary onClose={props.onClose} {...props} />
      )}
    />
  );
};

const AuthenticationManagerQuery = graphql__1ac4ae48bed5d63aced0;

export default AuthenticationManager;
